<template>
  <el-card class="h-full" :body-style="{ height: '100%', overflow: 'auto' }">
    <div class="flex items-center">
      <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">上侧边栏设置</span>
    </div>
    <div class="mt-20px">
      <el-form :model="upperSideBarForm" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="展示组件" prop="showComponent">
              <el-select :disabled="true" v-model="showComponent" placeholder="请选择展示组件">
                <el-option
                  v-for="(option, index) in modelList"
                  :key="index"
                  :label="option.name"
                  :value="option.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据来源" prop="dataSource">
              <el-select
                ref="upperSideBarSelect"
                :disabled="canEdit"
                v-model="upperSideBarForm.dataSource"
                placeholder="请选择数据来源"
                popper-class="data-source-select-tree"
                size="small"
                @visible-change="visibleSelectChange('upperSideBar', $event)"
              >
                <el-option
                  :label="upperSideBarColumnName"
                  :value="upperSideBarForm.dataSource"
                  :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
                >
                  <el-tree
                    :props="{
                      label: 'name',
                      children: 'child',
                    }"
                    class="text-white max-h-274px overflow-x-hidden data-source-tree"
                    ref="upperSideBarTree"
                    node-key="id"
                    highlight-current
                    :data="sideBarColumnData"
                    @node-click="treeNodeClick('upperSideBar', $event)"
                    :expand-on-click-node="false"
                    :default-expanded-keys="defaultExpandedKeys"
                  ></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="列表样式" prop="listType">
              <el-select
                :disabled="canEdit"
                v-model="upperSideBarForm.listType"
                placeholder="请选择列表样式"
              >
                <el-option
                  v-for="(option, index) in listType"
                  :key="index"
                  :label="option.name"
                  :value="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="展示行数" prop="row">
              <el-input-number
                :disabled="canEdit"
                v-model="upperSideBarForm.row"
                :min="1"
                :max="100"
                controls-position="right"
                class="max-w-1/1 !w-202px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="每行展示条数" prop="col">
              <el-input-number
                :disabled="canEdit"
                v-model="upperSideBarForm.col"
                :min="1"
                :max="100"
                controls-position="right"
                class="max-w-1/1 !w-202px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="展示内容" prop="displayContent">
              <el-checkbox-group v-model="upperSideBarForm.displayContent" :disabled="canEdit">
                <el-checkbox
                  label="显示摘要"
                  v-if="
                    upperSideBarForm.listType !== 'NewsThree' &&
                      upperSideBarForm.listType !== 'NewsFour'
                  "
                ></el-checkbox>
                <el-checkbox
                  label="显示时间"
                  v-if="upperSideBarForm.listType !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示分页"
                  v-if="upperSideBarForm.listType !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示栏目名称"
                  v-if="upperSideBarForm.listType !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox label="显示更多"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="flex items-center">
      <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">下侧边栏设置</span>
    </div>
    <div class="mt-20px">
      <el-form :model="lowerSideBarForm" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="展示组件" prop="showComponent">
              <el-select :disabled="true" v-model="showComponent" placeholder="请选择展示组件">
                <el-option
                  v-for="(option, index) in modelList"
                  :key="index"
                  :label="option.name"
                  :value="option.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据来源" prop="dataSource">
              <el-select
                ref="lowerSideBarSelect"
                :disabled="canEdit"
                v-model="lowerSideBarForm.dataSource"
                placeholder="请选择数据来源"
                popper-class="data-source-select-tree"
                size="small"
                @visible-change="visibleSelectChange('lowerSideBar', $event)"
              >
                <el-option
                  :label="lowerSideBarColumnName"
                  :value="lowerSideBarForm.dataSource"
                  :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
                >
                  <el-tree
                    :props="{
                      label: 'name',
                      children: 'child',
                    }"
                    class="text-white max-h-274px overflow-x-hidden data-source-tree"
                    ref="lowerSideBarTree"
                    node-key="id"
                    highlight-current
                    :data="sideBarColumnData"
                    @node-click="treeNodeClick('lowerSideBar', $event)"
                    :expand-on-click-node="false"
                    :default-expanded-keys="defaultExpandedKeys"
                  ></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="列表样式" prop="listType">
              <el-select
                :disabled="canEdit"
                v-model="lowerSideBarForm.listType"
                placeholder="请选择列表样式"
              >
                <el-option
                  v-for="(option, index) in listType"
                  :key="index"
                  :label="option.name"
                  :value="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="展示行数" prop="row">
              <el-input-number
                :disabled="canEdit"
                v-model="lowerSideBarForm.row"
                :min="1"
                :max="100"
                controls-position="right"
                class="max-w-1/1 !w-202px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="每行展示条数" prop="col">
              <el-input-number
                :disabled="canEdit"
                v-model="lowerSideBarForm.col"
                :min="1"
                :max="100"
                controls-position="right"
                class="max-w-1/1 !w-202px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="展示内容" prop="displayContent">
              <el-checkbox-group v-model="lowerSideBarForm.displayContent" :disabled="canEdit">
                <el-checkbox
                  label="显示摘要"
                  v-if="lowerSideBarForm.listType !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示时间"
                  v-if="lowerSideBarForm.listType !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示分页"
                  v-if="lowerSideBarForm.listType !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示栏目名称"
                  v-if="lowerSideBarForm.listType !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox label="显示更多"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="flex items-center">
      <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">底部栏设置</span>
    </div>
    <div class="mt-20px">
      <el-form :model="footerForm" ref="ruleForm" label-width="150px" class="demo-ruleForm">
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="展示组件" prop="showComponent">
              <el-select :disabled="true" v-model="showComponent" placeholder="请选择展示组件">
                <el-option
                  v-for="(option, index) in modelList"
                  :key="index"
                  :label="option.name"
                  :value="option.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据来源" prop="dataSource">
              <el-select
                ref="footerSelect"
                :disabled="canEdit"
                v-model="footerForm.dataSource"
                placeholder="请选择数据来源"
                popper-class="data-source-select-tree"
                size="small"
                @visible-change="visibleSelectChange('footer', $event)"
              >
                <el-option
                  :label="footerColumnName"
                  :value="footerForm.dataSource"
                  :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
                >
                  <el-tree
                    :props="{
                      label: 'name',
                      children: 'child',
                    }"
                    class="text-white max-h-274px overflow-x-hidden data-source-tree"
                    ref="footerTree"
                    node-key="id"
                    highlight-current
                    :data="footerColumnData"
                    @node-click="treeNodeClick('footer', $event)"
                    :expand-on-click-node="false"
                    :default-expanded-keys="defaultExpandedKeys"
                  ></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="列表样式" prop="listType">
              <el-select
                :disabled="canEdit"
                v-model="footerForm.listType"
                placeholder="请选择列表样式"
              >
                <el-option
                  v-for="(option, index) in listType"
                  :key="index"
                  :label="option.name"
                  :value="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="展示行数" prop="row">
              <el-input-number
                :disabled="canEdit"
                v-model="footerForm.row"
                :min="1"
                :max="100"
                controls-position="right"
                class="max-w-1/1 !w-202px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="每行展示条数" prop="col">
              <el-input-number
                :disabled="canEdit"
                v-model="footerForm.col"
                :min="1"
                :max="100"
                controls-position="right"
                class="max-w-1/1 !w-202px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="展示内容" prop="displayContent">
              <el-checkbox-group v-model="footerForm.displayContent" :disabled="canEdit">
                <el-checkbox
                  label="显示摘要"
                  v-if="footerForm.listType !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示时间"
                  v-if="footerForm.listType !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示分页"
                  v-if="footerForm.listType !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示栏目名称"
                  v-if="footerForm.listType !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox label="显示更多"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="w-full fixed bottom-20px left-1/2">
      <el-button
        v-if="canEdit === true"
        size="small"
        type="primary"
        @click="canEdit = false"
      >
        编辑
      </el-button>
      <el-button v-if="canEdit === false" size="small" type="primary" @click="submit">
        保存
      </el-button>
      <el-button v-if="canEdit === false" size="small" @click="cancel">
        取消
      </el-button>
    </div>
  </el-card>
</template>

<script>
import { WorkbenchSettingApi, ColumApi } from '@wiz-api/workbench'
import { treeToOneArray } from '@/assets/js/Common'
import { listType } from '../../js/config'

const workbenchSettingApi = new WorkbenchSettingApi()
const columApi = new ColumApi()
export default {
  data() {
    return {
      canEdit: true,
      showComponent: '列表',
      upperSideBarForm: {
        dataSource: '',
        listType: '',
        displayContent: ['显示摘要', '显示时间', '显示分页', '显示栏目名称', '显示更多'],
        row: 5,
        col: 1,
      },
      lowerSideBarForm: {
        dataSource: '',
        listType: '',
        displayContent: ['显示摘要', '显示时间', '显示分页', '显示栏目名称', '显示更多'],
        row: 5,
        col: 1,
      },
      footerForm: {
        dataSource: '',
        listType: '',
        displayContent: ['显示摘要', '显示时间', '显示分页', '显示栏目名称', '显示更多'],
        row: 5,
        col: 1,
      },
      modelList: [],
      sourceList: [],
      listType,
      columnFlattenData: [],
      defaultExpandedKeys: [],
      upperSideBarColumnName: '',
      sideBarColumnData: [],
      footerColumnData: [],
      lowerSideBarColumnName: '',
      footerColumnName: '',
    }
  },
  async created() {
    await this.getColumnData()
    await this.getSetting()
  },
  methods: {
    async getColumnData() {
      const [err, res] = await columApi.tree(0)
      if (!err) {
        const popularRankings = {
          name: '本周热门排行',
          id: '11111111-1111-1111-1111-111111111111',
        }
        const relatedRecommend = {
          name: '相关推荐',
          id: '22222222-2222-2222-2222-222222222222',
        }
        this.sideBarColumnData = [popularRankings, ...res]
        this.footerColumnData = [popularRankings, relatedRecommend, ...res]
        this.columnFlattenData = treeToOneArray(this.footerColumnData, 'child')
      }
    },
    visibleSelectChange(type, boolean) {
      this.$nextTick(() => {
        if (boolean) {
          this.$refs[`${type}Tree`].setCurrentKey(this[`${type}Form`].dataSource) // 设置选中元素
          this.defaultExpandedKeys = [this[`${type}Form`].dataSource]
        } else {
          const nodeDatas = this.$refs[`${type}Tree`].store.nodesMap
          _.forIn(nodeDatas, (val) => {
            val.expanded = false
          })
        }
      })
    },
    treeNodeClick(type, node) {
      this[`${type}Form`].dataSource = node.id
      this[`${type}ColumnName`] = node.name
      this.$refs[`${type}Select`].blur()
    },
    async getSource() {
      const [err, res] = await columApi.tree(0)
      if (!err && res) {
        this.sourceList = res
      }
    },
    async getSetting() {
      const [err, res] = await workbenchSettingApi.getWorkbenchSetting({ code: 'columnDetail' })
      if (!err && res) {
        if (res.config) {
          const config = JSON.parse(res.config)
          this.upperSideBarForm = config[0]
          this.upperSideBarColumnName = _.find(this.columnFlattenData, {
            id: this.upperSideBarForm.dataSource,
          })?.name
          this.lowerSideBarForm = config[1]
          this.lowerSideBarColumnName = _.find(this.columnFlattenData, {
            id: this.lowerSideBarForm.dataSource,
          })?.name
          this.footerForm = config[2]
          this.footerColumnName = _.find(this.columnFlattenData, {
            id: this.footerForm.dataSource,
          })?.name
        }
      }
    },
    async submit() {
      const [err] = await workbenchSettingApi.updateWorkbenchSetting({
        body: {
          config: JSON.stringify([this.upperSideBarForm, this.lowerSideBarForm, this.footerForm]),
          code: 'columnDetail',
        },
      })
      if (!err) {
        this.$message.success('修改成功')
        this.canEdit = true
      }
    },
    cancel() {
      this.getSetting()
      this.canEdit = true
    },
  },
}
</script>

<style lang="scss" scoped>
.data-source-tree {
  &::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-tree-node__content {
    height: 36px;
  }
}
</style>
<style lang="scss">
.data-source-select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
}
</style>
